import { render, staticRenderFns } from "./AddShortageItems.vue?vue&type=template&id=16b6f1e7&scoped=true&"
import script from "./AddShortageItems.vue?vue&type=script&lang=js&"
export * from "./AddShortageItems.vue?vue&type=script&lang=js&"
import style0 from "./AddShortageItems.vue?vue&type=style&index=0&id=16b6f1e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b6f1e7",
  null
  
)

export default component.exports